import { createSelector } from 'reselect';
import CheckoutSelector from '../../../Checkout/container/Checkout.selector';

const getGiftWrapValues = createSelector(
  CheckoutSelector.getGiftWrappingValues,
  (selectedGiftWrapValues) => ({
    name: selectedGiftWrapValues?.name,
    hasGiftWrapping: selectedGiftWrapValues?.hasGiftWrapping,
    optionId: selectedGiftWrapValues?.optionId,
    message: selectedGiftWrapValues?.message,
    brand: selectedGiftWrapValues?.brand,
    price: selectedGiftWrapValues?.price,
  })
);

export default getGiftWrapValues;
